module.exports = __webpack_public_path__ + "img/hs1.c48a163d.png";